import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-matching-dimensions',
  templateUrl: './help-matching-dimensions.component.html',
  styleUrls: ['./help-matching-dimensions.component.scss']
})
export class HelpMatchingDimensionsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
